interface transactionResultMessageI {
  status: string;
  amount?: number | null;
  coin: string;
  account?: string;
  transactionType: string;
}

const transactionResultMessage = (data: transactionResultMessageI) => {
  const { status, transactionType, amount, coin, account } = data;
  if (transactionType === "staking" || transactionType === "unstaking") {
    const statusText = status === "SUCCESS" ? "successfull" : "unsuccessfull";
    return `${amount} ${coin} ${transactionType} ${statusText}`;
  }
  if (transactionType === "withdraw") {
    const statusText = status === "SUCCESS" ? "withdrawn" : "not withdrawn";
    return `${coin} ${statusText} to ${account}`;
  }
  return null;
};

export { transactionResultMessage };
